export const GradientBackgroundsEnum = Object.freeze({
  PINK_ORANGE:
    "radial-gradient(ellipse at 30% 40%, #fce7f3 0%, transparent 60%), radial-gradient(ellipse at 70% 60%, #fef3c7 0%, transparent 50%), white",
  BLUE_VIOLET:
    "radial-gradient(ellipse at 70% 30%, #ddd6fe 0%, transparent 60%), radial-gradient(ellipse at 30% 70%, #e0e7ff 0%, transparent 50%), white",
  GREEN_YELLOW:
    "radial-gradient(ellipse at 50% 60%, #fef3c7 0%, transparent 60%), radial-gradient(ellipse at 20% 40%, #ecfdf5 0%, transparent 50%), white",
  VIOLET_PINK:
    "radial-gradient(ellipse at 40% 50%, #f3e8ff 0%, transparent 60%), radial-gradient(ellipse at 60% 20%, #fce7f3 0%, transparent 50%), white",
  BLUE_GREEN:
    "radial-gradient(ellipse at 60% 70%, #e0f2fe 0%, transparent 60%), radial-gradient(ellipse at 40% 30%, #ecfdf5 0%, transparent 50%), white",
});

export const GRADIENT_OPTIONS = Object.values(GradientBackgroundsEnum);
